<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>پیگیری سفارشات</h4>
        <div v-if="show" class="animated fadeIn" ref="container">
          <div class="row align-items-center text-center">
            <div class="col-6 d-flex align-items-end justify-content-end">
              <button v-b-modal.add-new-order class="btn iconed btn-secondary"><i
                class="icon-bd-plus"></i><span>جدید</span></button>
            </div>
          </div>
          <vs-table ref="table" :params="params" :options="options"/>
        </div>
      </div>
    </div>
    <b-modal
      ref="modal"
      id="add-new-order"
      size="xl"
      title="افزودن سفارش جدید"
      ok-title="ذخیره"
      cancel-title="لغو"
      @ok="createNewOrder"
      @cancel="hideModal"
    >
      <order-form ref="orderForm" @add-order-object="orderValues"></order-form>
    </b-modal>
  </div>
</template>


<script>
    import VsTable from "../../_framework/VsTable.vue";
    import VsTableMixin from "../../_framework/VsTableMixin.js";
    import OrderForm from "../../components/OrderForm";
    import axios from "axios";
    import BaseService from "../../_framework/api/BaseService";
    import CustomerOrderOperations from "../../components/CustomerOrderOperations";
    import * as bus from "vue";
    import EventBus from "../../bus.js";


    export default {
        props: ["accesses", "userAccess"],
        components: {
            VsTable,
            VsTableMixin,
            OrderForm,
            CustomerOrderOperations
        },
        mixins: [VsTableMixin],
        beforeMount() {
            this.options.access = checkAccess(this.$route.path);
            // console.log(this.options.access);
            this.show = !!this.options.access;
        },
        data() {
            return {
                orderModel: {},
                show: true,
                params: {
                    entity: "CustomerOrders",
                    reqUrl: "/GetAll",
                    headers: {
                        // id: {
                        //     title: 'شماره مشتری',
                        //     type: 'number',
                        //     rowAlignment: 'center',
                        // },
                        /*serveName: {
                          title: "سفارش دهنده",
                          type: "text",
                          rowAlignment: "center"
                        },*/
                        receiverName: {
                            title: "شرکت",
                            type: "text",
                            rowAlignment: "center"
                        },
                        ordersCount: {
                            title: "تعداد",
                            type: "number",
                            rowAlignment: "center"
                        },
                        date: {
                            title: "تاریخ تحویل",
                            type: "number",
                            rowAlignment: "center",
                            formatGregorianDateToJalaali: true
                        },
                        inventoryStatus: {
                            title: "عملیات",
                            inHeader: false,
                            component: "customer-order-operations",
                            label: "جزئیات سفارش",
                            rowAlignment: "center",
                            triggersRowClickEvent: true
                        }
                    }
                },
                options: {
                    hasActions: false,
                    clickableRows: true,
                    sortableHeaders: true,
                    hasActionsInHeader: false,
                    isEditable: false,
                    dataSourceType: "api",
                    innerBox: {
                        component: "order-details"
                    },
                    beforeDeleteEntity: input => {
                        this.deleteEntity(input.id);
                        // console.log(input.id)
                        return null;
                    },
                    beforeCreateEntity: input => {
                        if (input && input["materials"]) {
                            input["materials"] = input["materials"].map(p => {
                                return {
                                    material: p.material.id,
                                    percentage: p.percentage
                                };
                            });
                        }
                        if (input && input["unit"]) {
                            input["unit"] = input["unit"].id || input["unit"];
                        }
                        this.refreshTable();
                        return input;
                    },
                    beforeUpdateEntity: input => {
                        if (input && input["materials"]) {
                        }
                        if (input && input["unit"]) {
                            input["unit"] = input["unit"].id || input["unit"];
                        }
                        this.refreshTable();
                        return input;
                    },
                    beforeFetchEntityList: input => {
                        return input;
                    },
                    onRowClicked: row => {
                        this.$emit("onRowSelect", row);
                    },
                    onRowDoubleClicked: row => {
                        this.$emit("onRowDoubleClicked", row);
                    },

                    getTopRightButtons: () => {
                        let arr = [];
                        let searchToggleButton = {
                            component: "search-toggle-button"
                        };
                        arr.push(searchToggleButton);
                        return arr;
                    },
                   /* getTopLeftButtons: () => {
                        let arr = [];
                        let self = this;
                        let addItemButton = {
                            component: "toggle-table-actions-button",
                            params: {
                                onClick() {
                                    self.options.hasActions = !self.options.hasActions;
                                }
                            }
                        };
                        /!*let stackFilterButton = {
                          component: "stock-filter-button"
                        };*!/
                        // arr.push(stackFilterButton);
                        arr.push(addItemButton);

                        return arr;
                    }*/
                }
            };
        },
        mounted() {
            this.getAllCustomerOrders();
        },
        methods: {
            showModal() {
                this.$refs.modal.show();
            },
            hideModal() {
                this.$refs.modal.hide();
                this.refreshTable();
            },

            deleteEntity(id) {
                axios.delete(`CustomerOrders/Remove/${id}`).then((response) => {
                    this.$noty.warning("سفارش با موفقیت حذف شد");
                    this.refreshTable();
                }).catch((error) => {
                    console.log(error)
                })

            },
            refreshTable() {
                this.show = false;
                setTimeout(() => {
                    this.show = true;
                }, 50);
                // this.$refs.table.onFetchEntityList();
            },
            getAllCustomerOrders() {
                axios.get('CustomerOrders/GetAll').then((response) => {
                    this.refreshTable();
                }).catch((error) => {
                    console.log(error)
                })
            },
            orderValues(value) {

                // console.log(value);
                this.orderModel = value;

            },
            createNewOrder() {

                new BaseService('CustomerOrders', '/Create').create(this.orderModel).then((response) => {
                    // console.log(response.data);
                    this.$noty.success('سفارش با موفقیت اضافه شد');
                    this.$store.commit("REMOVE_ALL_ROWS_FROM_VS_TABLE_FEED");
                    this.$refs.orderForm.companySelected = false;
                    this.$refs.orderForm.childOrderObject = {};
                    this.$refs.orderForm.ordersArray = [];
                    // console.log(this.orderModel);
                    this.refreshTable();
                    this.getAllCustomerOrders();
                    this.orderModel = {};
                }).catch((error) => {
                    console.log(error)
                })
            },
            getFilesInnerBox() {
                let innerBox = {
                    options: {
                        clickableRows: false,
                        hasActions: false,
                        isEditable: false
                    },
                    params: {}
                };

                return innerBox;
            }
        }
    };
</script>

<style lang="scss">
  //@import '~vuejs-noty/dist/vuejs-noty.css';

  #nav {
    padding: 30px;

    a {
      font-weight: bold;
      color: #2c3e50;

      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }
</style>
